export default "__VITE_ASSET__umtBE0vV__"